import { SingleSelect } from 'Shared/forms/Inputs';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';
import { useVenue } from 'Shared/VenueProvider';


/*
	The parameter of a style that names one of the venue's own styles rather than setting css itself -
	the two button styles in buttonStyles.ts.

	StylesField roots the parameter editor at the tag's own 'params', so a bare field writes
	params.style. The options come off the venue document rather than the theme, so a style just built
	in the Style Builder is pickable without a reload; a stored name that is no longer in the list
	shows nothing until it is repointed, and the frontend falls back to its code base meanwhile and
	warns - see namedStyleCss().
*/
export function VenueStyleUi()
{
	const venue = useVenue();

	const options = () => Object.fromEntries(
		(venue.settings.frontend.customStyles ?? []).map(style => [style.name,style.name]));

	return (
		<LabelOnLeftWrap label='Style' narrow={true}>
			<SingleSelect field='style' options={options()} hideNone={true} />
		</LabelOnLeftWrap>
	);
}
